// @flow @format

import { Observable, from, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import type { StoreState } from '../types';
import { getS3BucketAndPath, getUserS3 } from '../reducer/auth';
import { injectAuth } from '../reducer';

const selectUserS3 = injectAuth(getUserS3);
const selectS3BucketAndPath = injectAuth(getS3BucketAndPath);

export function fetchJsonFromS3(state: StoreState, fileName: string): Observable<{}> {
  const s3 = selectUserS3(state);
  const [bucket, path] = selectS3BucketAndPath(state) || [];
  if (!s3 || !bucket || !path) return throwError(new TypeError('No Sts'));

  return from(s3.getObject({ Bucket: bucket, Key: path + fileName }).promise()).pipe(
    map(response => JSON.parse(response.Body.toString())),
    catchError(error => {
      // File not existed?
      if (error.code === 'AccessDenied') return of({});
      // rethrow
      else return throwError(error);
    })
  );
}

export function uploadJsonToS3(state: StoreState, fileName: string, jsonObj: {}): Observable<any> {
  const s3 = selectUserS3(state);
  const [bucket, path] = selectS3BucketAndPath(state) || [];
  if (!s3 || !bucket || !path) return throwError(new TypeError('No Sts'));

  return from(s3.putObject({ Bucket: bucket, Key: path + fileName, Body: JSON.stringify(jsonObj) }).promise());
}
